import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../configure_store";

interface AuthState {
  companyId: string;
  userId: string;
  token: string;
}

const initialState: AuthState = {
  companyId: "",
  userId: "",
  token: "",
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
    setCompanyId: (state, action: PayloadAction<string>) => {
      state.companyId = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    loginOut: (state, action: PayloadAction) => {
      state.companyId = "";
      state.userId = "";
      state.token = "";
      localStorage.clear();
    },
  },
});

export const { setUserId, setCompanyId, setToken, loginOut } =
  authSlice.actions;

export const getUserId = (state: RootState) => state.persistent.auth.userId;
export const getCompanyId = (state: RootState) =>
  state.persistent.auth.companyId;
export const getToken = (state: RootState) => state.persistent.auth.token;
const AuthReducer = authSlice.reducer;
export default AuthReducer;
